import { css, Theme } from '@emotion/react'

export const attachment = (theme: Theme) => css`
  width: 54px;
  height: 54px;
  border-radius: 13.035px;
  border: 1px solid ${theme.backgrounds.backgroundTwo};
  box-shadow: ${theme.boxShadows.small};
  object-fit: cover;
`

export const avatarField = (theme: Theme) => css`
  display: flex;
  padding: 20px;
  flex-direction: column;
  gap: 12px;
  border-radius: 17px;
  border: 1px dashed ${theme.backgrounds.backgroundOne};
  background: ${theme.backgrounds.backgroundFive};
`

export const avatarFieldError = (theme: Theme) => css`
  border: 1px dashed ${theme.colors.red};
`

export const avatarContainer = (theme: Theme) => css`
  display: flex;
  padding: 14px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-radius: 20px;
  border: 1px solid ${theme.backgrounds.backgroundOne};
  background: ${theme.backgrounds.backgroundFour};
  box-shadow: ${theme.boxShadows.small};
  overflow: hidden;
`

export const selectedImage = css`
  max-width: calc(100% - 32px);
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`

export const imageInput = css`
  cursor: pointer;
`

export const imageTitle = (theme: Theme) => css`
  font-weight: 700;
  color: ${theme.typographyColors.typographyFour};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 345px;
`

export const removeIcon = (theme: Theme) => css`
  path {
    stroke: ${theme.typographyColors.typographyThree};
  }
`

export const addIcon = (theme: Theme) => css`
  box-sizing: border-box;
  width: 48px;
  height: 48px;
  padding: 13px;
  border-radius: 14px;
  border: 1px solid ${theme.backgrounds.backgroundOne};
  background: ${theme.backgrounds.backgroundFour};
  box-shadow: ${theme.boxShadows.small};

  path {
    rotate: 45deg;
    transform-origin: center;
    width: 22px;
    height: 22px;
    stroke: ${theme.typographyColors.typographyThree};
  }
`

export const dndImageArea = css`
  display: flex;
  margin: 0 auto;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  cursor: pointer;
`

export const dndImageAreaTitle = (theme: Theme) => css`
  font-weight: 500;
  color: ${theme.typographyColors.typographyThree};
`

export const dndImageAreaHint = (theme: Theme) => css`
  font-weight: 400;
  color: ${theme.typographyColors.typographyThree};
`

export const dndImageAreaHintError = (theme: Theme) => css`
  font-weight: 700;
  color: ${theme.colors.red};
`
